import { objectToSnakeCase, objectToCamelCase } from '../utils'

import api from './api'

export default class Answer {
  static api = api.create(Answer)
  static readOnlyFields = ['id']

  constructor({
    id = null,
    question = null,
    text = null,
    datetimeCreated = 'null',
    authorRef = {},
  } = {}) {
    Object.assign(this, {
      id,
      question,
      text,
      datetimeCreated,
      authorRef,
    })
  }

  copy() {
    return new Answer(this)
  }

  update(data = {}) {
    return Object.assign(this.copy(), data)
  }

  static create(data = {}) {
    return new Answer(data)
  }

  static fromAPI(json = {}) {
    const jsonCamel = objectToCamelCase(json)
    return new Answer(jsonCamel)
  }
  /**
   *  Prep Answer data for the API. Can elect to include
   *  or exlude specific fields. The `Answer.readOnlyFields`
   *  are always excluded.
   **/
  static toAPI(answer, fields = [], excludeFields = []) {
    // By default, send the whole update
    let data = {}

    // If it's a partial update, get only the fields specified
    if (fields.length > 0) {
      fields.forEach(field => {
        data[field] = answer[field]
      })
    } else {
      data = answer
    }

    excludeFields = [...Answer.readOnlyFields, ...excludeFields]
    excludeFields.forEach(item => {
      delete data[item]
    })

    return objectToSnakeCase(data)
  }

  static checkIsInstance(obj, name) {
    if (!(obj instanceof Answer)) {
      throw Error(`${name} must be an instance of the Answer class.`)
    }
  }
}
